import { Link, useLocation } from "react-router-dom";
import { authService } from "../services/authService";
import { versionLabel, versionTitle } from "../lib/buildInfo";

// D15c3 : top bar fixe, 36px. AuthGuard wrapper pose `paddingTop: NAV_HEIGHT`
// une fois pour toutes les routes protégées — pas de marginTop par page.

export const NAV_HEIGHT = 36;

const NAV_LINKS: { to: string; label: string }[] = [
  { to: "/contexts", label: "Contextes" },
  { to: "/sessions", label: "Sessions" },
  { to: "/test-runs", label: "Test Runs" },
];

// Réservé aux admins — masqué pour les utilisateurs standards (pas de features
// qu'ils ne peuvent pas utiliser).
const ADMIN_LINK = { to: "/admin", label: "Admin" };

export default function NavBar({ onLogout }: { onLogout: () => void }) {
  const { pathname } = useLocation();
  const links = authService.isAdmin() ? [...NAV_LINKS, ADMIN_LINK] : NAV_LINKS;

  return (
    <nav
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        height: NAV_HEIGHT,
        background: "#0a0a0a",
        borderBottom: "1px solid #1f2937",
        display: "flex",
        alignItems: "center",
        padding: "0 16px",
        gap: 4,
        zIndex: 100,
        fontFamily: "system-ui, sans-serif",
      }}
    >
      <span
        style={{
          color: "#9ca3af",
          fontSize: 12,
          fontWeight: 700,
          letterSpacing: "0.06em",
          textTransform: "uppercase",
          marginRight: 12,
        }}
      >
        Streaming
      </span>
      {links.map((l) => {
        const active = pathname === l.to || pathname.startsWith(l.to + "/");
        return (
          <Link
            key={l.to}
            to={l.to}
            style={{
              color: active ? "#fff" : "#9ca3af",
              background: active ? "#1d4ed8" : "transparent",
              padding: "4px 12px",
              borderRadius: 5,
              fontSize: 13,
              fontWeight: active ? 600 : 500,
              textDecoration: "none",
            }}
          >
            {l.label}
          </Link>
        );
      })}
      <div style={{ flex: 1 }} />
      {versionLabel() && (
        <span
          data-testid="app-version"
          title={versionTitle()}
          style={{ color: "#6b7280", fontSize: 11, fontVariantNumeric: "tabular-nums", marginRight: 10 }}
        >
          {versionLabel()}
        </span>
      )}
      <button
        onClick={onLogout}
        style={{
          background: "transparent",
          color: "#9ca3af",
          border: "1px solid #1f2937",
          borderRadius: 5,
          padding: "3px 10px",
          fontSize: 11,
          cursor: "pointer",
          fontWeight: 500,
        }}
      >
        Logout
      </button>
    </nav>
  );
}
